import { instance2 } from "App/constants"
import { isNull, oneMonthBeforeToday, today } from "App/utils/helpers"
import { removeZeroInFront } from "utils/all"
import { lastOfDay, startOfDay } from "utils/dates"
const urlGetListKunjungan =
  "/registration/registration/listregistration_billing_all"

export const RESET_STATE_FORM_FILTER = {
  type_search: 0,
  type_rm: 0,
  qword: "",
  first_date: oneMonthBeforeToday(),
  finish_date: today(),
  status: 0,
  doctor: "",
  typeofcare_code: "",
  typeofcare_code_nama: "Pilih Tipe Layanan",

  pages: 1,
  limit: 10,
}

export const valueTypeSearch = [
  {
    label: "Semua",
    value: 0,
  },
  {
    label: "ID RM",
    value: 1,
  },
  {
    label: "ID Kunjungan",
    value: 7,
  },
  {
    label: "Nama",
    value: 2,
  },
  {
    label: "ID Tagihan",
    value: 3,
  },
  {
    label: "No Asuransi",
    value: 4,
  },
  {
    label: "No SEP",
    value: 5,
  },
  {
    label: "Created By",
    value: 6,
  },
]

export const getByFilterKunjungan = async (
  formFilter,
  pages,
  limit,
  url = urlGetListKunjungan,
) => {
  try {
    const api = await instance2.get(
      `${isNull(url) ? urlGetListKunjungan : url}`,
      {
        headers: {
          type_search:
            formFilter.type_search === 1
              ? removeZeroInFront(formFilter.type_search)
              : formFilter.type_search,
          type_rm: formFilter.type_rm,
          qword: formFilter.qword,
          first_date: startOfDay(formFilter.first_date),
          finish_date: lastOfDay(formFilter.finish_date),
          status: formFilter.status ? 1 : 0,
          doctor: formFilter.doctor,
          typeofcare_code: formFilter.typeofcare_code,
          pages,
          limit,
        },
      },
    )
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    align: "left",
    minWidth: "140px",
  },
  {
    id: "tagihan_id",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "layanan_name",
    disablePadding: false,
    label: "JENIS LAYANAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL REGISTRASI",
    align: "left",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "rm_name",
    disablePadding: false,
    label: "NAMA RM",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "patients_id",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "insurance_name",
    disablePadding: false,
    label: "ASURANSI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "company_name",
    disablePadding: false,
    label: "PERUSAHAAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "antrianno",
    disablePadding: false,
    label: "NO ANTRIAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "date_ob",
    disablePadding: false,
    label: "TANGGAL LAHIR",
    align: "left",
    sort: false,
    minWidth: "250px",
  },
  {
    id: "umur",
    disablePadding: false,
    label: "UMUR",
    align: "left",
    sort: false,
    minWidth: "250px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]
